import OrderDTO from "@/dto/order/OrderDTO";
import OrderMergeSplitStatus from "@/enum/OrderMergeSplitStatus";
import OrderSellerRemarksFlag from "@/enum/OrderSellerRemarksFlag";
import mainServerClient from "@/services/http/mainServerClient";
import { get } from "@/services/http/platformServer";

export interface PurchasingLabelScanPrintingSetting {
    checkBuyerRemarks?: boolean;
    checkLockedOrder?: boolean;
    checkRefundingOrder?: boolean;
    checkSellerRemarks?: boolean;
    checkSpecificSellerFlag?: boolean;
    checkWaybillPrintedOrder?: boolean;
    checkOnHoldOrder?: boolean;
    companyId?: number;
    specificSellerFlags?: OrderSellerRemarksFlag[];
}

export function getPurchasingLabelScanPrintingSetting(): Promise<PurchasingLabelScanPrintingSetting> {
    return mainServerClient.get("/purchasing_label_scan_printing_setting/get");
}

export function savePurchasingLabelScanPrintingSetting(
    purchasingLabelScanPrintingSetting: PurchasingLabelScanPrintingSetting,
): Promise<PurchasingLabelScanPrintingSetting> {
    return mainServerClient.post("/purchasing_label_scan_printing_setting/save", purchasingLabelScanPrintingSetting);
}

export interface OrderItemReadyStatus {
    orderItemId: number;
    /** @deprecated 不使用readyStatus判断是否备齐，而是通过readyQuantity与订单上的总数做对比 */
    readyStatus: boolean;
    /** 备齐的数量 */
    readyQuantity: number;
    /** 商品总数 */
    totalQuantity: number;
    /** 该OrderItem下所有的拿货标签ids */
    purchasingLabelIds: number[];
    orderItemOriginalId: string;
    /** 是否是删除的市场档口 */
    deleted: boolean;
}

export interface OrderReadyStatus {
    shopId: number;
    statsTaskId: number;
    mergeSplitStatus: OrderMergeSplitStatus;
    orderOriginalId: string;
    orderItemReadyStatuses: OrderItemReadyStatus[];
}

export interface PreparePurchasingLabelResponse {
    shopId: number;
    /** 拿货标签对应的订单编号 */
    orderOriginalId: string;
    /** 拿货标签对应的OrderItem编号 */
    orderItemOriginalId: string;
    /** 统计任务id */
    statsTaskId: number;
}

/** 备齐指定id商品标签 */
export function preparePurchasingLabel(
    id: number,
    printSetting: string,
    shipSetting: string,
): Promise<PreparePurchasingLabelResponse> {
    return mainServerClient.post(`/purchasing_label/prepare/${id}`, { printSetting, shipSetting });
}

/** 扫描打印拿货标签中获取订单 */
export function getPurchasingLabelOrderByOriginalId(
    shopId: number,
    orderOriginalId: string,
    orderItemOriginalId: string,
): Promise<OrderDTO> {
    return get(shopId, "/purchasing_label/get_order_by_original_id", { orderOriginalId, shopId, orderItemOriginalId });
}

/** 批量获取订单是否备齐 */
export function getOrderReadyStatusList(
    shopId: number,
    statsTaskId: number,
    orderItemOriginalIds: string[],
): Promise<OrderReadyStatus[]> {
    return mainServerClient.post("/purchasing_label/order_ready_status/list", {
        shopId,
        statsTaskId,
        orderItemOriginalIds,
    });
}

/** 手动备齐记录日志 */
export function manualPrepareLog(shopId: number, statsTaskId: number, orderItemOriginalId: string) {
    return mainServerClient.post("/purchasing_label/manually_prepare", { shopId, statsTaskId, orderItemOriginalId });
}

export function markPrintSyncPending(distributedId: number) {
    return mainServerClient.post(`/purchasing_label/mark_print_sync_pending/${distributedId}`);
}
